import React, { useState, useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import styled from 'styled-components';

// ✅ Styled Components
const StyledContainer = styled(Container)`
  background-color: #232830;
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const QuoteText = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  margin-bottom: 10px;
  padding: 0 20px;
`;

const AuthorText = styled.p`
  font-size: 14px;
  color: gray;
  text-align: center;
  margin-bottom: 20px;
`;

const LightbulbIcon = styled.div`
  font-size: 60px;
  color: yellow;
  animation: bounce 1.2s ease-in-out infinite alternate;

  @keyframes bounce {
    0% { transform: scale(1); }
    100% { transform: scale(1.2); }
  }
`;

const ContinueButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  padding: 12px;
  width: 80%;
  max-width: 300px;
  border-radius: 12px;
  margin-top: 20px;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: #E66A1A;
    border-color: #E66A1A;
  }
`;

// ✅ Quotes List
const quotes = [
  { text: "The best investment you can make is in yourself. Keep learning, keep growing.", author: "Anonymous" },
  { text: "An investment in knowledge pays the best interest.", author: "Benjamin Franklin" },
  { text: "Risk comes from not knowing what you are doing.", author: "Warren Buffett" },
  { text: "The stock market is filled with individuals who know the price of everything, but the value of nothing.", author: "Philip Fisher" },
  { text: "Time in the market beats timing the market.", author: "Ken Fisher" },
  { text: "The four most dangerous words in investing are: ‘this time it’s different.’", author: "Sir John Templeton" },
  { text: "It's not whether you're right or wrong, but how much money you make when you're right and how much you lose when you're wrong.", author: "George Soros" },
  { text: "The goal of a successful trader is to make the best trades. Money is secondary.", author: "Alexander Elder" },
  { text: "Do not be embarrassed by your failures, learn from them and start again.", author: "Richard Branson" },
  { text: "In investing, what is comfortable is rarely profitable.", author: "Robert Arnott" }
];

// ✅ Final Quotes Component
const FinalQuotes = ({ onContinue }) => {
  const [quote, setQuote] = useState({ text: "", author: "" });

  useEffect(() => {
    const randomQuote = quotes[Math.floor(Math.random() * quotes.length)];
    setQuote(randomQuote);
  }, []);

  return (
    <StyledContainer>
      {/* ✅ Ensuring `quote.text` and `quote.author` exist before rendering */}
      {quote.text ? (
        <>
          {/* ✅ Motivational Quote */}
          <QuoteText>"{quote.text}"</QuoteText>
          <AuthorText>- {quote.author}</AuthorText>

          {/* ✅ Animated Lightbulb */}
          <LightbulbIcon>💡</LightbulbIcon>

          {/* ✅ Continue Button */}
          <ContinueButton onClick={onContinue}>Continue</ContinueButton>
        </>
      ) : (
        <p>Loading...</p> // ✅ Fallback in case the quote hasn't loaded
      )}
    </StyledContainer>
  );
};

export default FinalQuotes;
